export const isPercentageInRange = (value, min = 0, max = 100) => {
  if (value === null || value === undefined) return false;

  const normalizedValue = String(value).trim();
  if (!normalizedValue) return false;
  if (!/^-?(?:\d+(?:\.\d*)?|\.\d+)$/.test(normalizedValue)) return false;

  const numberValue = Number(normalizedValue);
  return (
    Number.isFinite(numberValue) && numberValue >= min && numberValue <= max
  );
};

export const getPercentageRequestValue = (value, defaultValue = 100) => {
  if (value === null || value === undefined || value === "") {
    return defaultValue;
  }

  return Number(value);
};
